"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importDefault(require("styled-components"));

exports.Body = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding: 6.75%;\n\n    @media screen and (max-width: 768px) {\n        grid-template-columns: 1fr;\n    }\n"], ["\n    padding: 6.75%;\n\n    @media screen and (max-width: 768px) {\n        grid-template-columns: 1fr;\n    }\n"])));
exports.Aside = styled_components_1.default.aside(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    background-color: #e8e9ea;\n    border-radius: 0 8px 8px 0;\n    height: 100%;\n\n    @media screen and (max-width: 768px) {\n        grid-template-columns: 1fr;\n        border-radius: 0 0 8px 8px;\n    }\n"], ["\n    background-color: #e8e9ea;\n    border-radius: 0 8px 8px 0;\n    height: 100%;\n\n    @media screen and (max-width: 768px) {\n        grid-template-columns: 1fr;\n        border-radius: 0 0 8px 8px;\n    }\n"])));
exports.Article = styled_components_1.default.article(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin: 0 auto;\n    max-width: 960px;\n    background-color: #fff;\n    border-radius: 8px;\n    display: grid;\n    grid-template-columns: ", ";\n    align-items: center;\n    /* @media screen and (max-width: 960px) {\n        grid-template-columns: 1fr;\n    } */\n    @media screen and (max-width: 768px) {\n        grid-template-columns: 1fr;\n    }\n"], ["\n    margin: 0 auto;\n    max-width: 960px;\n    background-color: #fff;\n    border-radius: 8px;\n    display: grid;\n    grid-template-columns: ", ";\n    align-items: center;\n    /* @media screen and (max-width: 960px) {\n        grid-template-columns: 1fr;\n    } */\n    @media screen and (max-width: 768px) {\n        grid-template-columns: 1fr;\n    }\n"])), function (props) {
  return props.aside === false ? '1fr' : '2fr 1fr';
});
exports.default = {
  Article: exports.Article,
  Body: exports.Body,
  Aside: exports.Aside
};
var templateObject_1, templateObject_2, templateObject_3;